// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__SHCwA","container":"Loading_container__kdw-Y"};